import { createSelector, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { authExtraReducers } from '@store/reducres/auth.reducers'

export interface UserModel {
  username: string
  email: string
  ttl: string
}

export interface AuthState {
  user: UserModel | null
  loading: boolean
  error: string | null
}

const initialState: AuthState = {
  user: null,
  loading: false,
  error: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: authExtraReducers,
})

export default authSlice.reducer

export const selectAuth = (state: RootState) => state.auth
export const selectIsLoggedIn = createSelector(
  [selectAuth],
  (auth) => auth.user !== null
)
export const selectTtl = createSelector([selectAuth], (auth) =>
  auth.user ? new Date(auth.user.ttl) : null
)
export const selectAuthLoading = createSelector(
  [selectAuth],
  (auth) => auth.loading
)
export const selectAuthError = createSelector(
  [selectAuth],
  (auth) => auth.error
)
export const selectUser = createSelector([selectAuth], (auth) => auth.user)
